import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../../Contexts/AuthContext';

export function TitleSection({ title = "", subtitle = "" }) {

    const location = useLocation();
    const isMyProfilePage = location.pathname === '/my-profile';

    const { user } = useContext(AuthContext);

    if (isMyProfilePage) {
        return (
            <section className="w-full bg-gradient-radial lg:pt-28 pt-28 pb-10">
                <div className='w-full flex flex-col justify-between items-center'>
                    <h2 className="text-4xl sm:text-4xl lg:text-5xl font-bold font-urbanist text-white text-center">
                        My Profile
                    </h2>
                    <p className='mt-2 text-lg text-center text-gray-400 px-4 lg:px-48 capitalize font-urbanist'>
                        ( {(user?.role || "").replace(/-/g, ' ')} )
                    </p>
                </div>
            </section>
        )
    } else {
        return (
            <section className="w-full bg-gradient-radial lg:pt-20 pt-20 !pb-12 lg:!pb-16 lg:py-28">
                <div className="w-full lg:w-full flex flex-col items-center py-12">
                    <img className="md:w-[25rem] w-[15rem] h-auto" src="/assets/FWPI-logo.png" alt="FWPI Logo About Us" />
                </div>

                <div className='w-full flex flex-col justify-between items-center'>
                    {
                        !!title &&
                        <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center mb-8 lg:mb-8">
                            {title}
                        </h2>
                    }
                    {
                        !!subtitle &&
                        <p className='w-[90%] mt-2 text-lg text-center text-white px-4 lg:px-48 font-urbanist'>
                            {subtitle}
                        </p>
                    }
                </div>
            </section>
        )
    }
}
